import { combineReducers} from 'redux';
import { merge, mergeDeepWithKey, mergeDeepRight } from 'ramda';
import { normalizeChunk } from './schemas';

export const session = (state = {login: {}, session: {}}, { type, payload, meta, error }) => {
  switch (type) {
    case 'app/createSession':
      if (meta.done) {
        return merge(state, {login: payload});
      }
      return state;
    case 'app/fetchSession':
      if (meta.done) {
        return merge(state, {session: payload});
      }
      return state;
    case 'app/logout':
      return {};
    default: 
      return state;
  }
}

export const tabs = (state = [], {type, payload, meta, error}) => {
  switch (type) {
    case 'app/fetchTabs':
      if (meta.done) {
        return payload;
      }
      return state;
    default:
      return state
  }
}

export const visitorCounts = (state = {day: '', fields: {}}, {type, payload, meta, error}) => {
  switch (type) {
    case 'app/fetchCounts':
      if (meta.done) {
        var fields = {};
        payload.fields.forEach((field) => fields[field.type] = field.count);
        const {day} = payload;
        return merge(state, {fields, day});
      }
      return state;
    case 'app/incrementEntry':
      if (meta.done) {
        if (payload.visitor.visit_date === state.day) {
          return mergeDeepWithKey((k, l, r) => l + r, state, {fields: {[payload.visitor.visit_type]: 1}});
        }
      }
      return state;
    case 'app/decrementEntry':
      if (meta.done) {
        if (payload.visitor.visit_date === state.day) {
          return mergeDeepWithKey((k, l, r) => l > 1 ? l - r : 0, state, {fields: {[payload.visitor.visit_type]: 1}});
        }
      }
      return state;

    default:
      return state;
  }
}

export const bcp = (state = {last_search: '',
                             search_results: [],
                             patients: {}}, {type, payload, meta, error}) => {
  switch (type) {
    case 'app/searchPatient':
      if (meta.done) {
        return merge(state, {search_results: payload.results});
      }
      return state;
    case 'app/fetchPatient':
      if (meta.done) {
        return mergeDeepRight(state, {patients: {[payload.patient.id]: payload.patient}});
      }
      return state;
    case 'live/patient':
      return mergeDeepRight(state, {patients: {[payload.id]: payload}});
    default:
      return state;
  }
}

export const calendar = (state = {chunks: {}, appointments: {}}, {type, payload, meta, error}) => {
  switch (type) {
    case 'app/fetchCalendarDay':
      if (meta.done) {
        return mergeDeepRight(state, {chunks: payload.entities.chunk, appointments: payload.entities.appointments})
      }
      return state;
    case 'live/appointment':
      return mergeDeepRight(state, {appointments: {[payload.id]: payload}});
    case 'live/chunk':
      const chunk = normalizeChunk(payload);
      return mergeDeepRight(state, {chunks: chunk.entities.chunk, appointments: chunk.entities.appointments});
    default:
      return state;
  }
}

export default combineReducers({session, tabs, visitorCounts, bcp, calendar});



// WEBPACK FOOTER //
// ./src/store/reducers.js